import React, { Fragment } from "react";
import Animation from "../../../assets/images/Loading_icon.gif";

const Loader = () => {
  return (
    <>
      <div
        className="loading h-100vh  m-auto d-flex  align-items-center justify-content-center"
        style={{ background: "transparent" }}
      >
        <img
          src={Animation}
          alt="loading img"
          className="w-50 m-auto d-block"
        ></img>
        {/* <Spinner className="" animation="border" variant="secondary" /> */}
      </div>
    </>
  );
};

export default Loader;
